import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const ArrowLeftIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const DownloadIcon = ({ size = 14, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

const ChevronRight = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const API_BASE_URL = `${process.env.REACT_APP_BASE_API_URL}`;

const D = {
  page: { backgroundColor: "#ffffff", minHeight: "100vh", fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif", fontSize: "14px", color: "#1a1a1a" },
  container: { maxWidth: "1600px", margin: "0 auto", padding: "0 40px 48px 40px" },
  breadcrumb: { display: "flex", alignItems: "center", gap: "4px", padding: "12px 0 10px", fontSize: "12px", color: "#6b7280" },
  bcLink: { color: "#6b7280", textDecoration: "none", cursor: "pointer" },
  bcActive: { color: "#1a1a1a", fontWeight: 500 },
  bcSep: { color: "#9ca3af" },
  backArrow: { display: "inline-flex", alignItems: "center", cursor: "pointer", marginBottom: "16px", color: "#374151" },
  headerCard: { backgroundColor: "#ffffff", border: "1px solid #e5e7eb", borderRadius: "12px", padding: "24px 20px", marginBottom: "24px" },
  titleRow: { display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "16px" },
  pageTitle: { fontSize: "26px", fontWeight: "700", color: "#111827", margin: 0, lineHeight: 1.3 },
  badgeAwarded: { display: "inline-flex", alignItems: "center", gap: "5px", backgroundColor: "#d1fae5", border: "1px solid #10b981", color: "#065f46", borderRadius: "20px", padding: "3px 10px", fontSize: "12px", fontWeight: 600 },
  badgePending: { display: "inline-flex", alignItems: "center", gap: "5px", backgroundColor: "#fef3c7", border: "1px solid #fcd34d", color: "#92400e", borderRadius: "20px", padding: "3px 10px", fontSize: "12px", fontWeight: 600 },
  badgeDotAwarded: { width: "7px", height: "7px", borderRadius: "50%", backgroundColor: "#10b981", display: "inline-block" },
  badgeDotPending: { width: "7px", height: "7px", borderRadius: "50%", backgroundColor: "#f59e0b", display: "inline-block" },
  timeline: { display: "flex", alignItems: "flex-start", flexShrink: 0 },
  tlStep: { display: "flex", flexDirection: "column", alignItems: "center", width: "80px", position: "relative" },
  tlConnector: { position: "absolute", top: "15px", left: "calc(50% + 15px)", width: "calc(100% - 14px)", height: "2px", backgroundColor: "#e5e7eb", zIndex: 0 },
  tlConnectorPassed: { position: "absolute", top: "15px", left: "calc(50% + 15px)", width: "calc(100% - 14px)", height: "2px", backgroundColor: "#2F7A87", zIndex: 0 },
  tlIcon: { width: "30px", height: "30px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", fontWeight: "700", zIndex: 1, position: "relative", flexShrink: 0, color: "#fff" },
  tlIconPassed: { width: "30px", height: "30px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", fontWeight: "700", zIndex: 1, position: "relative", flexShrink: 0, color: "#fff", backgroundColor: "#2F7A87" },
  tlIconActive: { width: "30px", height: "30px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", fontWeight: "700", zIndex: 1, position: "relative", flexShrink: 0, color: "#fff", backgroundColor: "#2F7A87" },
  tlIconInactive: { width: "30px", height: "30px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", fontWeight: "700", zIndex: 1, position: "relative", flexShrink: 0, color: "#fff", backgroundColor: "#e5e7eb" },
  tlLabel: { fontSize: "10px", textAlign: "center", color: "#374151", marginTop: "5px", fontWeight: 600, lineHeight: 1.3 },
  tlLabelPassed: { fontSize: "10px", textAlign: "center", color: "#2F7A87", marginTop: "5px", fontWeight: 600, lineHeight: 1.3 },
  tlLabelActive: { fontSize: "10px", textAlign: "center", color: "#2F7A87", marginTop: "5px", fontWeight: 600, lineHeight: 1.3 },
  tlLabelInactive: { fontSize: "10px", textAlign: "center", color: "#6b7280", marginTop: "5px", fontWeight: 600, lineHeight: 1.3 },
  tlDate: { fontSize: "10px", textAlign: "center", color: "#6b7280", lineHeight: 1.3 },
  metaRow: { display: "flex", gap: "20px", marginTop: "16px", flexWrap: "wrap" },
  metaLabel: { fontSize: "11px", color: "#9ca3af", marginBottom: "2px" },
  metaValue: { fontSize: "13px", color: "#374151", fontWeight: 500 },
  statsBar: { display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "24px" },
  statsLeft: { display: "flex", alignItems: "center", gap: "20px" },
  statItem: { display: "flex", alignItems: "center", gap: "5px", color: "#6b7280", fontSize: "13px" },
  dlBtn: { display: "inline-flex", alignItems: "center", gap: "6px", border: "1px solid #2F7A87", borderRadius: "20px", padding: "6px 20px", fontSize: "13px", fontWeight: 500, color: "#2F7A87", backgroundColor: "#fff", cursor: "pointer", textDecoration: "none" },
  twoCol: { display: "flex", gap: "20px", alignItems: "flex-start" },
  leftCol: { width: "340px", flexShrink: 0 },
  rightCol: { flex: 1, minWidth: 0 },
  panel: { backgroundColor: "#ffffff", border: "1px solid #e5e7eb", borderRadius: "10px", padding: "20px", marginBottom: "16px" },
  panelTitle: { fontSize: "17px", fontWeight: "700", color: "#111827", marginBottom: "20px" },
  factRow: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 0" },
  factLabel: { fontSize: "15px", color: "#9ca3af" },
  factValue: { fontSize: "15px", color: "#111827", fontWeight: 700, textAlign: "right" },
  factValueTeal: { fontSize: "15px", color: "#2F7A87", fontWeight: 700, textAlign: "right" },
docRow: {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "10px 0",
  gap: "12px",
},
docLeft: {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  flex: 1,
  minWidth: 0,
},
docIcon: {
  width: "36px",
  height: "36px",
  borderRadius: "8px",
  backgroundColor: "#fee2e2",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "12px",
  fontWeight: 700,
  color: "#dc2626",
  flexShrink: 0,
},
docTextWrap: {
  flex: 1,
  minWidth: 0,
},
docName: {
  fontSize: "13px",
  fontWeight: 600,
  color: "#111827",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
},
docMeta: {
  fontSize: "11px",
  color: "#9ca3af",
  marginTop: "2px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
},
dlCircle: {
  width: "36px",
  height: "36px",
  borderRadius: "50%",
  backgroundColor: "#2F7A87",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  flexShrink: 0,
},
  dlCircle: { width: "36px", height: "36px", borderRadius: "50%", backgroundColor: "#2F7A87", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0 },
  descText: { fontSize: "13.5px", color: "#374151", lineHeight: "1.75", margin: 0, textAlign: "justify" },
  bPanel: { backgroundColor: "#ffffff", border: "1px solid #e5e7eb", borderRadius: "10px", overflow: "hidden", marginBottom: "16px" },
  bHeader: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px 12px", borderBottom: "1px solid #e5e7eb" },
  bTitle: { fontSize: "15px", fontWeight: "700", color: "#111827", margin: 0 },
  viewAll: { fontSize: "12px", color: "#2F7A87", fontWeight: 600, cursor: "pointer", textDecoration: "none" },
  bThRow: { display: "grid", gridTemplateColumns: "60px 1fr 130px", padding: "10px 20px", backgroundColor: "#f9fafb", borderBottom: "1px solid #e5e7eb" },
  bTh: { fontSize: "12px", color: "#6b7280", fontWeight: 500 },
  bThR: { fontSize: "12px", color: "#6b7280", fontWeight: 500, textAlign: "right" },
  bRow: { display: "grid", gridTemplateColumns: "60px 1fr 130px", padding: "18px 20px", alignItems: "center" },
  bRank: { fontSize: "13px", fontWeight: 600, color: "#111827" },
  bName: { fontSize: "14px", color: "#111827", fontWeight: 500 },
  bNameWinner: { fontSize: "14px", color: "#2F7A87", fontWeight: 600 },
  bAmt: { fontSize: "13.5px", color: "#111827", textAlign: "right", fontWeight: 600 },
  relSection: { marginTop: "24px", backgroundColor: "#ffffff", border: "1px solid #e5e7eb", borderRadius: "12px", padding: "24px" },
  relHeader: { display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" },
  relTitle: { fontSize: "15px", fontWeight: "700", color: "#111827", margin: 0 },
  relGrid: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px" },
  relCard: { backgroundColor: "#ffffff", border: "1px solid #e5e7eb", borderRadius: "10px", padding: "16px" },
  relCardTitle: { fontSize: "14px", fontWeight: "700", color: "#111827", marginBottom: "5px", lineHeight: 1.4 },
  relOrg: { fontSize: "12.5px", color: "#6b7280", marginBottom: "2px" },
  relCity: { fontSize: "12px", color: "#6b7280", marginBottom: "12px" },
  relClLabel: { fontSize: "11px", color: "#9ca3af", marginBottom: "3px" },
  relClRow: { display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" },
  relDate: { fontSize: "12.5px", fontWeight: 600, color: "#111827" },
};

export default function TenderAwarded() {
  const { tenderId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tenderData, setTenderData] = useState(null);
  const [relatedTenders, setRelatedTenders] = useState([]);
  const [stats, setStats] = useState({ views: 0, bookmarks: 0, users: 0 });

  useEffect(() => {
    if (tenderId) {
      fetchTenderData();
    }
  }, [tenderId]);

  const fetchTenderData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_BASE_URL}/api/tender-award/${tenderId}`);
      if (!response.ok) {
        if (response.status === 404) {
          setError('Tender not found');
        } else {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        setLoading(false);
        return;
      }
      const data = await response.json();
      if (data.success) {
        setTenderData(data);
        if (data.tender_number) {
          fetchRelatedTenders(data.tender_number);
        }
        fetchStats(data.tender?.id || tenderId);
      } else {
        setError(data.error || 'Failed to fetch tender data');
      }
    } catch (err) {
      console.error('Error fetching tender:', err);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const fetchRelatedTenders = async (tenderNum) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/gem/related-tenders/${encodeURIComponent(tenderNum)}`);
      const data = await response.json();
      if (data.success) {
        setRelatedTenders(data.data || []);
      }
    } catch (err) {
      console.error('Error fetching related tenders:', err);
    }
  };

  const fetchStats = async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/tender-stats/${id}`);
      const data = await response.json();
      if (data.success) {
        setStats({
          views: data.stats?.views || 0,
          bookmarks: data.stats?.interested || 0,
          users: data.stats?.applies || 0
        });
      }
    } catch (err) {
      console.error('Error fetching stats:', err);
    }
  };

  const formatCurrency = (amount) => {
    if (!amount) return 'N/A';
    const num = parseFloat(amount);
    if (isNaN(num)) return 'N/A';
    if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `₹${(num / 100000).toFixed(2)} Lakh`;
    return `₹${num.toLocaleString('en-IN')}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    } catch {
      return 'N/A';
    }
  };

  const getTimelineStatus = (stepDate) => {
    if (!stepDate || stepDate === 'N/A' || stepDate === 'Pending') return 'inactive';
    try {
      const date = new Date(stepDate);
      if (isNaN(date.getTime())) return 'inactive';
      const now = new Date();
      return date <= now ? 'passed' : 'active';
    } catch {
      return 'inactive';
    }
  };

  const getFileExt = (mime, name) => {
    const lowerName = (name || '').toLowerCase();
    if (mime?.includes("pdf") || lowerName.endsWith(".pdf")) return "PDF";
    if (mime?.includes("word") || lowerName.endsWith(".doc") || lowerName.endsWith(".docx")) return "DOC";
    if (mime?.includes("excel") || lowerName.endsWith(".xls") || lowerName.endsWith(".xlsx")) return "XLS";
    if (mime?.includes("zip") || lowerName.endsWith(".zip")) return "ZIP";
    return "DOC";
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading tender details...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <div style={{ color: 'red', marginBottom: '16px' }}>{error}</div>
        <button onClick={() => navigate(-1)} style={{ padding: '8px 16px', cursor: 'pointer' }}>
          Go Back
        </button>
      </div>
    );
  }

  if (!tenderData) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>No tender found</div>
      </div>
    );
  }

  const { tender, evaluation } = tenderData;
  const safeTender = tender || {};
  const safeEvaluation = evaluation || [];
  const documents = tenderData.documents || [];
  const hasBidders = safeEvaluation && safeEvaluation.length > 0;
  const l1Winner = hasBidders ? (safeEvaluation.find(e => e.is_winner) || safeEvaluation[0] || null) : null;
  const l1Name = l1Winner?.seller_name || 'Pending';
  const l1Price = l1Winner?.total_price || null;
  const displayTitle = safeTender.project_name || safeTender.work_name || tenderData.tender_number || 'Tender Details';
  const displayDepartment = safeTender.department_name || safeTender.organization_name || 'N/A';
  const displayMinistry = safeTender.ministry_name || 'N/A';
  const displayLocation = safeTender.location || 'N/A';
  const displayDescription = safeTender.project_name || safeTender.work_name || 'No description available';
  const displayValue = safeTender.estimated_value || null;
  const isAwarded = safeTender.status === 'Awarded' || safeTender.status === 'Closed' || hasBidders;

  const quickFacts = [
    { label: "Tender Number", value: safeTender.tender_number || tenderData.tender_id || 'N/A', teal: false },
    { label: "Category", value: safeTender.tender_category || 'N/A', teal: false },
    { label: "Estimated Bid Value", value: formatCurrency(displayValue), teal: false },
    { label: "Status", value: safeTender.status || 'N/A', teal: false },
    { label: "Awarded To", value: hasBidders ? l1Name : 'Pending', teal: hasBidders },
    { label: "Awarded Value", value: hasBidders && l1Price ? formatCurrency(l1Price) : 'Pending', teal: false },
  ];

  const bidders = safeEvaluation
    .sort((a, b) => (a.rank_position || 99) - (b.rank_position || 99))
    .slice(0, 10)
    .map(b => ({
      rank: b.rank || `#${b.s_no || 0}`,
      name: b.seller_name || 'Unknown',
      amount: formatCurrency(b.total_price),
      bold: b.is_winner || false
    }));

  const timelineSteps = [
    { label: "Published", date: formatDate(safeTender.published_date || safeTender.created_at), imgSrc: "/icons/published.png" },
    { label: "Pre-bid Meeting", date: formatDate(safeTender.pre_bid_meeting_date) || 'N/A', imgSrc: "/icons/prebid.png" },
    { label: "Submission Deadline", date: formatDate(safeTender.submission_deadline), imgSrc: "/icons/submission.png" },
    { label: "Technical Opening", date: formatDate(safeTender.bid_open_date) || 'N/A', imgSrc: "/icons/technical.png" },
    { label: "Award Date", date: hasBidders ? formatDate(new Date()) : 'Pending', imgSrc: "/icons/award.png" },
  ];

  const hasRelated = relatedTenders && relatedTenders.length > 0;

  return (
    <div style={D.page}>
      <div style={D.container}>
        <nav style={D.breadcrumb}>
          <a href="#" style={D.bcLink} onClick={(e) => { e.preventDefault(); navigate('/'); }}>Home</a>
          <span style={D.bcSep}><ChevronRight /></span>
          <a href="#" style={D.bcLink} onClick={(e) => { e.preventDefault(); navigate('/results'); }}>Results</a>
          <span style={D.bcSep}><ChevronRight /></span>
          <span style={D.bcActive}>{displayTitle.substring(0, 50)}</span>
        </nav>
        <div style={D.backArrow} onClick={() => navigate(-1)}><ArrowLeftIcon /></div>
       
        <div style={D.headerCard}>
          <div style={D.titleRow}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "10px", flexWrap: "wrap" }}>
                <h1 style={D.pageTitle}>{displayTitle}</h1>
                {isAwarded ? (
                  <span style={D.badgeAwarded}>
                    <span style={D.badgeDotAwarded} />
                    Awarded
                  </span>
                ) : (
                  <span style={D.badgePending}>
                    <span style={D.badgeDotPending} />
                    Pending
                  </span>
                )}
              </div>
              <div style={D.metaRow}>
                <div>
                  <div style={D.metaLabel}>Department</div>
                  <div style={D.metaValue}>{displayDepartment}</div>
                </div>
                <div>
                  <div style={D.metaLabel}>Ministry</div>
                  <div style={D.metaValue}>{displayMinistry}</div>
                </div>
                <div>
                  <div style={D.metaLabel}>Location</div>
                  <div style={D.metaValue}>{displayLocation}</div>
                </div>
              </div>
            </div>
            <div style={D.timeline}>
              {timelineSteps.map((step, i) => {
                const status = getTimelineStatus(step.date);
                const isPassed = status === 'passed';
                const isActive = status === 'active';
                
                let iconStyle = D.tlIconInactive;
                let labelStyle = D.tlLabelInactive;
                let connectorStyle = D.tlConnector;
                
                if (isPassed) {
                  iconStyle = D.tlIconPassed;
                  labelStyle = D.tlLabelPassed;
                  connectorStyle = D.tlConnectorPassed;
                } else if (isActive) {
                  iconStyle = D.tlIconActive;
                  labelStyle = D.tlLabelActive;
                }
                
                return (
                  <div key={i} style={D.tlStep}>
                    {i < timelineSteps.length - 1 && <div style={connectorStyle} />}
                    <div style={iconStyle}>
                      <img src={step.imgSrc} alt={step.label} width="20" height="20" />
                    </div>
                    <div style={labelStyle}>{step.label}</div>
                    <div style={D.tlDate}>{step.date}</div>
                  </div>
                );
              })}
            </div>
          </div>
          <div style={D.statsBar}>
            <div style={D.statsLeft}></div>
          </div>
        </div>

        <div style={D.twoCol}>
          <div style={D.leftCol}>
            <div style={D.panel}>
              <div style={D.panelTitle}>Quick Facts</div>
              {quickFacts.map((f, i) => (
                <div key={i} style={{ ...D.factRow, borderBottom: i < quickFacts.length - 1 ? "1px solid #f3f4f6" : "none" }}>
                  <span style={D.factLabel}>{f.label}</span>
                  <span style={f.teal ? D.factValueTeal : D.factValue}>{f.value}</span>
                </div>
              ))}
            </div>

            <div style={D.panel}>
              <div style={D.panelTitle}>
                Documents {documents.length > 0 && `(${documents.length})`}
              </div>

           {documents.length > 0 ? (
  documents.map((doc, idx) => (
    <div
      key={doc.id || idx}
      style={{
        ...D.docRow,
        borderBottom: idx < documents.length - 1 ? "1px solid #f3f4f6" : "none",
      }}
    >
      <div style={D.docLeft}>
        <div style={D.docIcon}>
          {getFileExt(doc.mime_type, doc.name)}
        </div>
        <div style={D.docTextWrap}>
          <div style={D.docName} title={doc.name || "Tender Document"}>
            {doc.name || "Tender Document"}
          </div>
          <div style={D.docMeta} title={
            [doc.type, doc.file_size_formatted].filter(Boolean).join(" • ")
          }>
           
          </div>
        </div>
      </div>
      {doc.url ? (
        <a
          href={doc.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
          title="Download"
        >
          <div style={D.dlCircle}>
            <DownloadIcon size={15} color="#fff" />
          </div>
        </a>
      ) : (
        <div
          style={{
            ...D.dlCircle,
            backgroundColor: "#e5e7eb",
            cursor: "not-allowed",
          }}
          title="No download URL"
        >
          <DownloadIcon size={15} color="#9ca3af" />
        </div>
      )}
    </div>
  ))
) : (
                <div style={D.docRow}>
                  <div style={D.docLeft}>
                    {/* <div
                      style={{
                        ...D.docIcon,
                        backgroundColor: "#f3f4f6",
                        color: "#9ca3af",
                      }}
                    >
                     
                    </div> */}
                    <div>
                      <div style={{ ...D.docName, color: "#6b7280" }}>
                        No documents available
                      </div>
                      <div style={D.docMeta}>
                        Documents have not been uploaded for this tender
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div style={D.panel}>
              <div style={D.panelTitle}>Description</div>
              <p style={D.descText}>{displayDescription}</p>
            </div>
          </div>

          <div style={D.rightCol}>
            <div style={D.bPanel}>
              <div style={D.bHeader}>
                <span style={D.bTitle}>Bidders List</span>
                <a href="#" style={D.viewAll} onClick={(e) => e.preventDefault()}>View All</a>
              </div>
              <div style={D.bThRow}>
                <span style={D.bTh}>Rank</span>
                <span style={D.bTh}>Bidder Name</span>
                <span style={D.bThR}>Bid Amount</span>
              </div>
              {bidders.length > 0 ? (
                bidders.map((b, i) => (
                  <div key={i} style={{ ...D.bRow, borderBottom: i < bidders.length - 1 ? "1px solid #f3f4f6" : "none", backgroundColor: "#fff" }}>
                    <span style={D.bRank}>{b.rank}</span>
                    <span style={b.bold ? D.bNameWinner : D.bName}>{b.name}</span>
                    <span style={D.bAmt}>{b.amount}</span>
                  </div>
                ))
              ) : (
                <div style={{ padding: '20px', textAlign: 'center', color: '#6b7280' }}>No bidders found</div>
              )}
            </div>
          </div>
        </div>

        {hasRelated && (
          <div style={D.relSection}>
            <div style={D.relHeader}>
              <span style={D.relTitle}>Related Tenders</span>
              <a href="#" style={{ fontSize: "13px", color: "#2F7A87", fontWeight: 600, textDecoration: "none" }} onClick={(e) => e.preventDefault()}>View All Related</a>
            </div>
            <div style={D.relGrid}>
              {relatedTenders.map((t, i) => (
                <div key={i} style={D.relCard}>
                  <div style={D.relCardTitle}>{t.title || 'N/A'}</div>
                  <div style={D.relOrg}>{t.org || 'N/A'}</div>
                  <div style={D.relCity}>{t.city || 'N/A'}</div>
                  <div style={D.relClLabel}>Closing Date</div>
                  <div style={D.relClRow}>
                    <span style={D.relDate}>{t.date || 'N/A'}</span>
                    <span style={{ fontSize: "11px", fontWeight: 600, color: "#059669", backgroundColor: "#d1fae5", borderRadius: "20px", padding: "2px 8px" }}>{t.badge || 'New'}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}